import React from 'react';
import { Layout, Menu, Avatar, Dropdown, Space, Button } from 'antd';
import { UserOutlined, LogoutOutlined, SettingOutlined, DashboardOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import type { MenuProps } from 'antd';

const { Header } = Layout;

const AppHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  // 用户菜单
  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人信息',
      onClick: () => {
        // TODO: 实现个人信息页面
      }
    },
    ...(user?.is_admin ? [{
      key: 'admin',
      icon: <SettingOutlined />,
      label: '管理面板',
      onClick: () => navigate('/admin')
    }] : []),
    {
      type: 'divider' as const
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: logout
    }
  ];

  // 主导航菜单
  const navMenuItems: MenuProps['items'] = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: '仪表板',
      onClick: () => navigate('/dashboard')
    },
    {
      key: '/tickets',
      icon: <FileTextOutlined />,
      label: '工单列表',
      onClick: () => navigate('/tickets')
    }
  ];

  const selectedKeys = [location.pathname];

  return (
    <Header className="app-header">
      <div className="app-logo">
        DMS企微审批
      </div>
      
      <div style={{ flex: 1, marginLeft: 24 }}>
        <Menu
          mode="horizontal"
          selectedKeys={selectedKeys}
          items={navMenuItems}
          style={{ 
            border: 'none', 
            background: 'transparent',
            minWidth: 0,
            flex: 'auto'
          }}
        />
      </div>

      <div className="user-menu">
        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottomRight"
          trigger={['click']}
        >
          <Button type="text" className="user-avatar">
            <Space>
              <Avatar 
                size="small" 
                src={user?.avatar_url} 
                icon={<UserOutlined />}
              />
              <span style={{ display: window.innerWidth > 768 ? 'inline' : 'none' }}>
                {user?.name}
              </span>
            </Space>
          </Button>
        </Dropdown>
      </div>
    </Header>
  );
};

export default AppHeader;
